export const episodeCardStyles = {
  root: {
    display: 'flex',
    '&:has(#episode-card-text:hover) #episode-card-img': {
      transform: 'scale(1.1)',
    },
    height: '100%',
  },
  cover: {
    position: 'relative',
    overflow: 'hidden',
    borderRadius: 4,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '&:hover #episode-card-img': {
      transform: 'scale(1.1)',
    },
  },
  coverImg: {
    zIndex: 0,
    transition: 'transform .25s ease-in-out, opacity 500ms',
    cursor: 'pointer',
    objectFit: 'cover',
    // Apply a slight scale by default to prevent jittering on hover
    transform: 'scale(1.005)',
  },
  coverImgWide: {
    width: '100%',
  },
  coverImgTall: {
    height: '100%',
  },
  companyLogoImg: {
    position: 'absolute',
    top: 8,
    left: 8,
    borderRadius: 2,
    pointerEvents: 'none',
    boxShadow: '0px 4px 12px 0px rgba(0, 0, 0, 0.65)',
  },
  hideToolbar: {
    opacity: 0,
    transform: 'translateY(30%)',
    transition: 'opacity 0.3s, transform 0.3s',
  },
  titleContainer: {
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    WebkitLineClamp: 3,
    cursor: 'pointer',
  },
  tagContainer: {
    display: 'flex',
    gap: 1,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  bookmarkIcon: {
    ml: 'auto',
    cursor: 'pointer',
    color: 'grey150',
    width: 22,
    height: 22,
    '&:hover': {
      opacity: 0.8,
    },
  },
  bookmarkIconButton: {
    p: 0,
    ml: 'auto',
  },
  bookmarkIconActive: {
    color: 'secondary.main',
  },
};

export const episodeBannerStyles = {
  root: {
    position: 'relative',
    overflow: 'hidden',
    borderRadius: 4,
    color: 'text.contrast',
    display: 'flex',
    justifyContent: 'center',
    '&:hover #episode-cover-img': {
      transform: 'scale(1.1)',
    },
  },
  coverImage: {
    width: '100%',
    objectFit: 'cover',
    transform: 'scale(1.005)',
    transition: 'transform .25s ease-in-out',
  },
  gradientContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'column',
    p: 3,
  },
  companyLogo: {
    backgroundColor: 'white',
    borderRadius: 2,
    height: 70,
    width: 70,
    boxShadow: '0px 4px 12px 0px rgba(0, 0, 0, 0.65)',
  },
  cardBody: {
    display: 'flex',
    flexDirection: 'column',
  },
  textContainer: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: 0.5,
  },
  text: {
    color: 'text.contrast',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    WebkitLineClamp: 5,
    WebkitBoxOrient: 'vertical',
  },
  pillContainer: {
    display: 'flex',
    gap: 1,
    flexDirection: 'row',
    alignItems: 'center',
  },
  buttons: { display: 'flex', alignItems: 'flex-end', gap: 1, mt: 2 },
  buttonsRight: { display: 'flex', gap: 1.5, ml: 'auto' },
  bookmarkIcon: {
    color: 'white',
    cursor: 'pointer',
    backgroundColor: 'rgba(25, 0, 0, 0.3)',
    borderRadius: '50%',
    ml: 'auto',
    width: 32,
    height: 32,
    p: 0.5,
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.4)',
    },
  },
  bookmarkIconButton: {
    p: 0,
  },
};
